import { Interface } from '@ethersproject/abi'
import { ChainId } from '@kwikswap/bsc-sdk'
import V_EXCHANGE_ABI from './v_exchange.json'
import V_FACTORY_ABI from './v_factory.json'

const V_FACTORY_ADDRESSES: { [chainId in ChainId]: string } = {
  [ChainId.MAINNET]: '0xDf05e63b8Cc480787179c700132450105Ca62AAF',
  [ChainId.TESTNET]: '0x9c83dCE8CA20E9aAF9D3efc003b2ea62aBC08351'
}

const V_FACTORY_INTERFACE = new Interface(V_FACTORY_ABI)
const V_EXCHANGE_INTERFACE = new Interface(V_EXCHANGE_ABI)

export { V_FACTORY_ADDRESSES, V_FACTORY_INTERFACE, V_FACTORY_ABI, V_EXCHANGE_INTERFACE, V_EXCHANGE_ABI }
